import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

// Recording that a prize was posted.
//
// The date is asked for rather than taken from the clock, because the item is usually sent before
// anyone gets round to recording it, and a date that cannot be trusted is worse than no date.
//
// The item is asked for separately from the prize name because the terms allow a substitute of equal
// or greater value, so what was won and what arrived are not always the same thing.

const today = () => new Date().toISOString().slice(0, 10);

export default function LcvFulfilmentDialog(props) {
     const { win, isBusy, onCancel, onConfirm } = props;

     const [fulfilledOn, setFulfilledOn] = useState(
          win?.fulfilledOn ? String(win.fulfilledOn).slice(0, 10) : today(),
     );
     const [itemSupplied, setItemSupplied] = useState(win?.itemSupplied || win?.prizeName || "");

     const isDateValid = fulfilledOn !== "" && new Date(fulfilledOn) <= new Date(today());
     const isItemValid = itemSupplied.trim().length > 0 && itemSupplied.trim().length <= 200;

     return (
          <Dialog open onClose={onCancel} fullWidth maxWidth="sm">
               <DialogTitle>
                    {win?.isFulfilled ? "Correct the fulfilment" : "Mark as sent"}
               </DialogTitle>

               <DialogContent>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                         {win?.prizeName} won by {win?.firstName} {win?.lastName} at {win?.dealerName}.
                    </Typography>

                    <TextField
                         label="Date sent"
                         type="date"
                         value={fulfilledOn}
                         onChange={(event) => setFulfilledOn(event.target.value)}
                         error={fulfilledOn !== "" && !isDateValid}
                         helperText={
                              fulfilledOn !== "" && !isDateValid ? "The date cannot be in the future." : " "
                         }
                         InputLabelProps={{ shrink: true }}
                         fullWidth
                         sx={{ mb: 2 }}
                    />

                    <TextField
                         label="Item supplied"
                         value={itemSupplied}
                         onChange={(event) => setItemSupplied(event.target.value)}
                         error={itemSupplied !== "" && !isItemValid}
                         helperText={
                              itemSupplied !== "" && !isItemValid
                                   ? "Enter the item supplied, up to 200 characters."
                                   : "Change this if a substitute was sent."
                         }
                         fullWidth
                    />
               </DialogContent>

               <DialogActions>
                    <Button type="button" onClick={onCancel} disabled={isBusy}>
                         Cancel
                    </Button>
                    <Button
                         type="button"
                         variant="contained"
                         disabled={!isDateValid || !isItemValid || isBusy}
                         onClick={() =>
                              onConfirm({
                                   participantGamePlayCodeId: win.participantGamePlayCodeId,
                                   fulfilledOn: new Date(fulfilledOn).toISOString(),
                                   itemSupplied: itemSupplied.trim(),
                              })
                         }
                    >
                         Save
                    </Button>
               </DialogActions>
          </Dialog>
     );
}
